namespace TabAurous.Reports {
    export namespace PriceBifurcationService {
        export const baseUrl = 'Reports/PriceBifurcation';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<PriceBifurcationRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetVouchers(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<Common.Vouchers>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Reports/PriceBifurcation/List",
            GetVouchers = "Reports/PriceBifurcation/GetVouchers"
        }

        [
            'List', 
            'GetVouchers'
        ].forEach(x => {
            (<any>PriceBifurcationService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
